<template>
  <div class="ManageGroup">
    <div class="container-fluid paddding-right-0px">
      <div class="table-responsive margin-Top-1Perc margin-left-0Point3Perc">
        <table class="table table-striped">
          <thead>
           <tr v-if="getGroupList.length !== 0">
             <th class="text-align-center font-size-15px border-right">IsPublic</th>
              <th class="text-align-center font-size-15px border-right">Group Name</th>
              <th class="text-align-center font-size-15px">Action</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="groupObj in getGroupList" :key="groupObj.groupId" v-bind:groupObj="groupObj">
              <td class="text-align-center text-valign-middle border-right col-lg-2">{{groupObj.IsPublic ? 'Yes' : 'No'}}</td>
              <td class="text-align-center text-valign-middle border-right col-lg-7">{{groupObj.GroupName}}</td>
              <td class="text-align-center text-valign-middle col-lg-3">
                <a class="cursor-pointer" @click="performClickOperation($event,'edit',groupObj)"> Edit </a>|
                <!-- <a class="cursor-pointer" @click="performClickOperation($event,'milestone',groupObj)" v-bind:class="{'opacity-point3 cursor-default': groupObj.M365Enabled}"> Milestones </a>| -->
                <a class="cursor-pointer" @click="performClickOperation($event,'milestone',groupObj)"> Milestones </a>|
                <a class="cursor-pointer" @click="setShowConfirmationBoxAsTrue($event,true,groupObj)"> Delete </a>
              </td> 
            </tr>
          </tbody>
       </table>
      </div>
    </div>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteGroupString" v-bind:postfixString="postDeleteGroupString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedGroup"></confirmation-alert>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <edit-group v-if="showEditGroupOverlay" v-bind:selectedGroupObj="selectedGroupObj" @showEditGroupOverlay="updateShowEditOverlayOverlay" @showSpinner="updateShowSpinnerFlag" @refreshGroupList="RefreshGroupList"></edit-group>
    <milestone-overlay v-if="showMilestoneOverlay" v-bind:selectedGroupObj="selectedGroupObj" @closeOverlay="updateShowMilestoneOverlayFlag" @showSpinner="updateShowSpinnerFlag"></milestone-overlay>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div>
</template>
<script>
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import MilestoneOverlay from '@/components/MilestoneOverlay'
import AlertBox from '@/components/AlertOverlay'
import EditGroup from '@/components/UpdateGroupDetailsOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  created: function () {
    this.getGroups()
  },
  data: function () {
    return {
      groupList: [],
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showConfirmationBox: false,
      prefixDeleteGroupString: 'Are you sure you want to delete ',
      postDeleteGroupString: '',
      selectedGroupObj: null,
      showEditGroupOverlay: false,
      showMilestoneOverlay: false
    }
  },
  methods: {
    isCertificatePresent: function (groupObj) {
      if (groupObj.Certificate !== undefined && groupObj.Certificate !== null && groupObj.Certificate !== 'null' && groupObj.Certificate !== '') {
        if (groupObj.Certificate.CertificateFile !== undefined && groupObj.Certificate.CertificateFile !== null && groupObj.Certificate.CertificateFile !== 'null' && groupObj.Certificate.CertificateFile !== '') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    RefreshGroupList (value) {
      if (value) {
        this.getGroups()
      }
    },
    updateShowMilestoneOverlayFlag (value) {
      // AK: Used for closing dialog when user pressed X of Milestone overlay.
      this.showMilestoneOverlay = value.closeOverlay
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value.closeOverlay
    },
    updateShowEditOverlayOverlay (value) {
      // AK: Used for closing dialog when user pressed X or after successful updation
      this.showEditGroupOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowSpinnerFlag (value) {
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    setShowConfirmationBoxAsTrue: function (event, flagToUpdate, groupObj) {
      // AK: Used when user pressed delete to open delete Group overlay
      this.showConfirmationBox = flagToUpdate
      this.selectedGroupObj = groupObj
      this.postDeleteGroupString =
        '\'' + this.selectedGroupObj.GroupName + '\' group?'
    },
    performClickOperation: function (event, operationToPerform, groupObj) {
      // AK: Update current selected group object.
      this.selectedGroupObj = groupObj
      switch (operationToPerform) {
        case 'edit':
          this.showEditGroupOverlay = true
          // AK: Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'milestone':
          // if (!this.selectedGroupObj.M365Enabled) {
          var flag = true
          if (flag) {
            this.showMilestoneOverlay = true
            // AK: Disable Background Scrolling
            this.$store.state.isOverlayVisible = true
          } else {
            // console.log('It\'s Mentora Moments Group')
          }
          break
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Group overlay
      this.showConfirmationBox = value
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        } else {
          _this.groupList = storeObj.state.groupList
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false

              // AK: Show group List data after getting from server
              _this.groupList = responseObj.data
              // console.log(JSON.stringify(_this.groupList))
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    deleteSelectedGroup (value) {
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.selectedGroupObj.GroupId !== undefined ||
          this.selectedGroupObj !== null
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          // AK: Hide Delete Confirmation Box
          _this.showConfirmationBox = false
          groupService
            .deleteGroup(
              storeObj.state.access_token,
              this.selectedGroupObj.GroupId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // AK: Refresh Course List
                  _this.getGroups()
                } else {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                  // this.showSpinner = false
                  this.$store.state.isLoading = false
                }
              },
              errorObj => {
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected COURSE Object is NULL hence declined DELETE COURSE OPERATION'
          )
        }
      }
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'edit-group': EditGroup,
    'loader': Loader,
    'milestone-overlay': MilestoneOverlay
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    }
  },
  name: 'ManageGroup'
}
</script>
<style scoped>
.vertical-align {
  display: flex;
  align-items: center;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ManageGroup {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
  text-decoration: none;
} 
a:visited{
  color: #2c3e50;
  text-decoration: none;
}
a:hover {
  color: #2c3e50;
  text-decoration: none;
}
a:active {
  color: #2c3e50;
  text-decoration: none;
}
a{
  color: #2c3e50 !important;
}
.btn-text-color {
  color: #2c3e50;
}

.cursor-pointer {
  cursor: pointer;
}
.margin-left-2Point7Perc {
  margin-left: 2.7%;
}
.margin-right-1Point1Perc {
  margin-right: 1.1%;
}
.table > tbody > tr > td {
  padding: 1%;
}
 .margin-left-0Point3Perc
{
	margin-left: 0.3%;
}
.paddding-right-0px{
  padding-right:0%;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.opacity-point3 {
  opacity: 0.3;
}
.cursor-default {
  cursor: default !important;
}
.text-decoration-underline {
  text-decoration: underline;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
</style>


// WEBPACK FOOTER //
// src/components/ManageGroup.vue